export default {
  data() {
    return {
      captchaPlugin: null,
      captchaBiz: {
        params: {},
        cb: null,
        business: {}
      }
    };
  },
  beforeUnmount() {
    if (!this.$sn.validate.empty(this.captchaPlugin)) {
      this.captchaPlugin.destroyCaptcha();
      if (document.getElementById('aliyunCaptcha-mask')) document.getElementById('aliyunCaptcha-mask').remove();
      if (document.getElementById('aliyunCaptcha-window-popup')) document.getElementById('aliyunCaptcha-window-popup').remove();
      this.captchaPlugin = null;
      this.captchaBiz = {
        params: {},
        cb: null,
        business: {}
      };
    }
  },
  methods: {
    captcha_mixin_verify(func) {
      const {
        prefix,
        restrict
      } = func;
      if (!this.$sn.getConfig('aliyunCaptchaPlugin')) return false;
      if (this.$sn.validate.empty(this.$sn.getConfig(prefix + 'CaptchaTimeRange'))) return false;
      if (!this.$sn.validate.range(this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'HHmmss'), this.$sn.getConfig(prefix + 'CaptchaTimeRange'))) {
        return false;
      }
      if (!this.$sn.validate.empty(restrict) && !this.$sn.validate.empty(this.$sn.getConfig(prefix + 'CaptchaRestrict'))) {
        if (!this.$sn.getConfig(prefix + 'CaptchaRestrict').includes(restrict)) return false;
      }
      return true;
    },
    captcha_mixin_initial(func) {
      if (!this.captcha_mixin_verify(func)) return false;
      const verify = (result) => {
        if (result && this.$sn.validate.json(result)) {
          const {
            params,
            cb,
            business
          } = this.$sn.format.clone(this.captchaBiz);
          this.captcha_mixin_hide();
          this.$set(params.data, 'captchaVerifyParam', JSON.parse(result));
          this.$sn.assembly.loading(true);
          this.$sn.utils.ordinaryRequest({
            ...params,
            data: JSON.stringify(params.data)
          }).then(res => {
            cb(res, business);
          });
        }
        else {
          this.captcha_mixin_hide();
          this.$sn.assembly.modal({
            caption: this.$sn.format.caption(this.$sn.utils.getSessionStorage('HospitalMessages').C.C017, ['安全验证']),
            isCancel: false
          });
        }
      };
      let rem = 1;
      const width = window.innerWidth;
      if (width <= 320) {
        rem = Math.floor(width / 320);
      }
      window.initAliyunCaptcha({
        region: 'cn',
        prefix: 'jnx8ox',
        SceneId: 'l21nzrmt',
        mode: 'popup',
        element: '#captcha-element',
        button: '#captcha-interaction',
        captchaVerifyCallback: verify,
        onBizResultCallback: () => {},
        getInstance: (instance) => {
          this.captchaPlugin = instance;
        },
        language: 'cn',
        rem: rem,
        autoRefresh: false
      });
    },
    captcha_mixin_exhibition() {
      if (!this.$sn.validate.empty(this.captchaBiz) && !this.$sn.validate.empty(this.captchaBiz.params) && !this.$sn.validate.empty(this.captchaBiz.cb)) {
        this.captchaPlugin.refresh();
        this.captchaPlugin.show();
      }
      else {
        this.$sn.assembly.modal({
          caption: this.$sn.format.caption(this.$sn.utils.getSessionStorage('HospitalMessages').C.C018, ['业务信息']),
          isCancel: false
        });
      }
    },
    captcha_mixin_hide() {
      this.captchaPlugin.hide();
      this.captchaBiz = {
        params: {},
        cb: null,
        business: {}
      };
    }
  }
};
